import { css } from 'linaria';

export const priceStyle = css`
  font-weight: 700 !important;
`;

export const image = css`
  width: 40px;
  height: 40px;
  /* for image alt text */
  overflow: hidden;
  border-radius: 20px;
`;

export const descriptionStyle = css`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const mobileProduct = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const tabletProduct = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const leftSide = css`
  display: flex;
  min-width: 0;

  & > * + * {
    margin-left: 12px;
  }
`;

export const flexVerticalCenter = css`
  display: flex;
  align-items: center;
`;

export const textWrapper = css`
  min-width: 0;
`;

export const mediumPlusScreenProduct = css`
  display: flex;
  align-items: center;

  &.spaceBetween {
    justify-content: space-between;
  }

  &.flexEnd {
    justify-content: flex-end;

    & > * + * {
      margin-left: 16px;
    }
  }
`;
